const initialState = {
    remarkValue: [],
};

const remarkReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_REMARK':
            return {
                ...state,
                remarkValue: action.payload,
            };
        case 'LOGOUT':
            return {
                ...state,
                remarkValue: initialState.remarkValue,
            };
        default:
            return state;
    }
};

export default remarkReducer;